var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pui-lightbox",
    {
      ref: _vm.COMMENT_LIGHTBOX_REF,
      attrs: {
        "default-header-label": _vm.$t("commentLightbox.title"),
        "close-on-e-s-c": false,
      },
      on: {
        "puilightbox:close": function ($event) {
          return _vm.emitClose()
        },
      },
    },
    [
      _c(
        "pui-grid-container",
        [
          _c("comments-tab", {
            attrs: { "comment-details": _vm.commentDetails },
            on: {
              "close-lightbox": function (refresh) {
                return _vm.emitClose(refresh)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }